export const environments: any = {
  development: {
    REACT_APP_NETCORE_REGISTER_KEY: "b2634270df9910921e238f82be217d9f",
    REACT_APP_MARKETING_API:
      "https://devapi.taxmann.dev/marketing/api/v1/marketing/api/v1/",
    REACT_APP_NODE_ENV: "development",
    REACT_APP_NODE_LEARNING_URL: "https://devapi.taxmann.dev/learning/api/v1",
    REACT_APP_NODE_DASHBOARD_BASE_URL:
      "https://devapi.taxmann.dev/dashboard/api/v1/",
    REACT_APP_DOT_NET_BASE_URL:
      "https://lbackoffice.taxmann.com/researcnest/api/",
    REACT_APP_REDIS_URL:
      "https://devapi.taxmann.dev/research3/api/v1/research_module/",
    REACT_APP_ENCODE: "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
    REACT_APP_ENDMILE_API_SERVER:
      "https://devapi.taxmann.dev/msc/api/v1/endmile/",
    REACT_APP_NODE_BOOKSTORE_BASE_URL:
      "https://devapi.taxmann.dev/bookstore/api/v1/",
    REACT_APP_RAZOR_PAY_KEY: "rzp_test_qxZW6zdMVeKlpf",
    REACT_APP_CDN_URL: "https://cdn.taxmann.dev/",
    RESET_PASSWORD_SCREEN: "https://dev.taxmann.com/gp/auth/resetPassword",
    REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL: "https://devapi.taxmann.dev/sessionmgmt/api/v1/",
  },
  uat: {
    REACT_APP_NETCORE_REGISTER_KEY: "b2634270df9910921e238f82be217d9f",
    REACT_APP_MARKETING_API:
      "https://uatapi.taxmann.com/marketing/api/v1/marketing/api/v1/",
    REACT_APP_NODE_ENV: "uat",
    REACT_APP_NODE_LEARNING_URL: "https://learningapi-uat.taxmann.com/learning",//update
    REACT_APP_NODE_DASHBOARD_BASE_URL:
      "https://uatapi-new.taxmann.com/bookstore-dashboard/",//update
    REACT_APP_DOT_NET_BASE_URL: "https://dotnetapi-uat.taxmann.com/researcnest/api/",//update
    REACT_APP_REDIS_URL:
      "https://researchapi-uat.taxmann.com/research_module/",//update
    REACT_APP_ENCODE: "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
    REACT_APP_ENDMILE_API_SERVER:
      "https://uatapi.taxmann.com/msc/api/v1/endmile/",
    REACT_APP_NODE_BOOKSTORE_BASE_URL:
      "https://uatapi-new.taxmann.com/bookstore/",//update
    REACT_APP_RAZOR_PAY_KEY: "rzp_test_qxZW6zdMVeKlpf",
    REACT_APP_CDN_URL: "https://cdn.taxmann.dev/",
    RESET_PASSWORD_SCREEN: "https://uat.taxmann.com/gp/auth/resetPassword", //update
    REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL: "https://session-uat.taxmann.com/api/",//update
  },
  staging: {
    REACT_APP_NETCORE_REGISTER_KEY: "b2634270df9910921e238f82be217d9f",
    REACT_APP_MARKETING_API:
      "https://uatapi.taxmann.com/marketing/api/v1/marketing/api/v1/",
    REACT_APP_NODE_ENV: "staging",
    REACT_APP_NODE_LEARNING_URL:
      "https://learningapi-stag.taxmann.com/learning",
    REACT_APP_NODE_DASHBOARD_BASE_URL:
      "https://preprodapi.taxmann.com/bookstore-dashboard/",
    REACT_APP_DOT_NET_BASE_URL: "https://stagingapi.taxmann.com/api/",
    REACT_APP_REDIS_URL:
      "https://researchapi-stag.taxmann.com/research_module/",
    REACT_APP_ENCODE: "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
    REACT_APP_ENDMILE_API_SERVER:
      "https://uatapi.taxmann.com/msc/api/v1/endmile/",
    REACT_APP_NODE_BOOKSTORE_BASE_URL:
      "https://preprodapi.taxmann.com/bookstore/",
    REACT_APP_RAZOR_PAY_KEY: "rzp_live_o2Fh5USXaEgp8b",
    REACT_APP_CDN_URL: "https://cdn.taxmann.com/",
    RESET_PASSWORD_SCREEN: "https://preprod.taxmann.com/gp/auth/resetPassword",
    REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL:  "https://session-stag.taxmann.com/api/"
  },
  production: {
    REACT_APP_NETCORE_REGISTER_KEY: "0ec5ef80e56cf82f8a6b71d2bb8d5cca",
    REACT_APP_MARKETING_API:
      "https://liveapi.taxmann.com/marketing/api/v1/marketing/api/v1/",
    REACT_APP_NODE_ENV: "production",
    REACT_APP_NODE_LEARNING_URL:
      "https://learningapi-live.taxmann.com/learning",
    REACT_APP_NODE_DASHBOARD_BASE_URL:
      "https://prodapibookstore.taxmann.com/bookstore-dashboard/",
    REACT_APP_DOT_NET_BASE_URL: "https://liveresearchapi.taxmann.com/api/",
    REACT_APP_REDIS_URL:
      "https://researchapi-live.taxmann.com/research_module/",
    REACT_APP_ENCODE: "dsdgjSWDhjKEYGEN232xsdf5Asf5Op",
    REACT_APP_ENDMILE_API_SERVER:
      "https://liveapi.taxmann.com/msc/api/v1/endmile/",
    REACT_APP_NODE_BOOKSTORE_BASE_URL:
      "https://prodapibookstore.taxmann.com/bookstore/",
    REACT_APP_RAZOR_PAY_KEY: "rzp_live_o2Fh5USXaEgp8b",
    REACT_APP_CDN_URL: "https://cdn.taxmann.com/",
    RESET_PASSWORD_SCREEN: "https://taxmann.com/gp/auth/resetPassword",
    REACT_APP_NODE_DASHBOARD_BASE_SESSION_MANAGEMENT_URL: "https://session-live.taxmann.com/api/",
  },
};

export const VALIDATION_REGEX_PATTERN = {
  mobileNumber: /^[1-9]{1}[0-9]{9}$/,
  emailPattern:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  mobile: /^[1-9]{1}[0-9]*$/,
  alphabet: /^[a-zA-Z ]*$/,
  linkedin_profile_url:
    /(https?)?:?(\/\/)?(([w]{3}||\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
  url: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
  floatNumbers: /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/,
  validMarks: /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/,
  names: /^[a-zA-Z .]*$/,
};

export const PAN_REGEX = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;

export const SEO_MAPPING = {
  HOME_PAGE: {
    API_VALUE: "HOME_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/",
  },
  DASHBOARD_PAGE: {
    API_VALUE: "DASHBOARD_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/home",
  },
  UPCOMING_EVENTS_PAGE: {
    API_VALUE: "UPCOMING_EVENTS_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/upcoming-events",
  },
  PAST_EVENTS_PAGE: {
    API_VALUE: "PAST_EVENTS_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/events",
  },
  PRACTICE_AREA_PAGE: {
    API_VALUE: "PRACTICE_AREA_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/subjects",
  },
  PRODUCT_DETAILS: {
    API_VALUE: "PRODUCT_DETAILS",
    PATTERN: /(\d+)-/,
    PARAMS: ["eventId"],
    URL_CONTAINS: [],
  },
  RECOMMENDED_VIDEOS_PAGE: {
    API_VALUE: "RECOMMENDED_VIDEOS_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/recommended-videos",
  },
  MY_LIST: {
    API_VALUE: "MY_LIST",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/my-list",
  },
  EVENTS_WORKSHOP_PAGE: {
    API_VALUE: "EVENTS_WORKSHOP_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/events/workshops",
  },
  EVENTS_WEBINAR_PAGE: {
    API_VALUE: "EVENTS_WEBINAR_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/events/webinars",
  },
  EVENTS_MASTERCLASS_PAGE: {
    API_VALUE: "EVENTS_MASTERCLASS_PAGE",
    PATTERN: /(\d+)-/,
    PARAMS: [],
    URL_CONTAINS: "/events/masterclasses",
  },
};

export enum Currency {
  INR = "INR",
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}

export const CurrencySybmol: any = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
};
export enum ProductAttachmentTypes {
  UPLOAD_BASE_IMAGE = 1,
  UPLOAD_THUMBNAIL_IMAGE = 2,
  UPLOAD_BOOK_SAMPLE_CHAPTER = 3,
  UPLOAD_BOOK_PREFACE = 4,
  UPLOAD_BOOK_CONTENT = 5,
  UPLOAD_BOOK_VIDEO_LINK = 6,
  UPLOAD_BOOK_PRESENTATION = 7,
}

export enum ProductCategoryENUM {
  BOOK = "BOOK",
  JOURNAL = "JOURNAL",
  DVD = "DVD",
  ENEWSLETTER = "ENEWS",
  ADIT = "ADIT",
  RESEARCH = "RESEARCH",
  PRACTICE = "PRACTICE",
  EXAMS = "EXAM",
  BUNDLE = "BUNDLE",
  ISSUE = "ISSUE",
}
export enum ProductFormatTypeENUM {
  "VIRTUAL" = "VIRTUAL",
  "HARD" = "HARD",
  "POCKET" = "POCKET",
}

export enum ProductBadgeEnum {
  PREORDER = "PREORDER",
  BESTSELLER = "BESTSELLER",
  NEWRELEASE = "NEWRELEASE",
  POPULAR = "POPULAR",
  TRENDING = "TRENDING",
}

export enum SortByEnum {
  RELEASE_DATE_ASCENDING = "dlh",
  RELEASE_DATE_DECENDING = "dhl",
  PRICE_LOW_TO_HIGH = "plh",
  PRICE_HIGH_TO_LOW = "phl",
  RELEVANCE = "rank",
  CUSTOM = "custom",
  DECREASING = "desc",
  INCREASING = "asc",
  DEFAULT = "default",
}

export const sortByOptions = [
  {
    title: "Latest First",
    value: SortByEnum.DECREASING,
  },
  {
    title: "Oldest First",
    value: SortByEnum.INCREASING,
  },
  {
    title: "Default",
    value: SortByEnum.DEFAULT,
  },
];

export const apiConstants = {
  email: "email",
  password: "password",
  ipAddress: "ipAddress",
  userAgent: "userAgent",
  device: "device",
  os: "os",
  osVersion: "osVersion",
  browser: "browser",
  browserVersion: "browserVersion",
  deviceType: "deviceType",
  domainname: "domainname",
  countrycode: "countrycode",
  name: "name",
  mobile: "mobile",
  profession: "profession",
  professionOther: "professionOther",
  state: "state",
  productEditionId: "productEditionId",
  planKey: "planKey",
};

export const urlPrefix = "gp";

export interface CheckoutInformation {
  cartSource: string;
  billingId: string | number;
  shippingId: string | number;
  checkoutCart: string;
}

export const taxmannAccountDetails = {
  "Name of the Account": "Taxmann Allied Services Pvt. Ltd.",
  "Account Number": "50200071884962",
  "Name of the Bank": "HDFC Bank Limited",
  "IFSC Code": "HDFC0003992",
  "MICR Code": "110240384",
  "SWIFT Code": "HDFCINBB",
} as any;

export const taxmannContactDetails = {
  email: "sales@taxmann.com",
  number: "011-45562222",
  address: "Regd. Office:-59/32, New Rohtak Road, Karol Bagh, New Delhi-110005",
} as {
  email: string;
  number: string;
  address: string;
};

export enum OrderStatusENUM {
  PROCESSING = "PROCESSING",
  ACCEPTED = "ACCEPTED",
  YET_TO_BE_DISPATCHED = "YET_TO_BE_DISPATCHED",
  YET_TO_BE_ACTIVATED = "YET_TO_BE_ACTIVATED",
  ACTIVATED = "ACTIVATED",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
  CANCELLED = "CANCELLED",
  RETURNED = "RETURNED",
  DEACTIVATED = "DEACTIVATED",
}
export enum PaymentModes {
  RAZORPAY = 1,
  CHEQUE_DD,
  NEFT,
  COD,
  WALLET_NO_PAY,
  SHOPSE,
  RAZORPAY_RECURRING,
}

const colors = {
  // order status text colors
  order_accepted: "#B230F2",
  order_activated: "#F2D330",
  order_processing: "#305BF2",
  order_awaiting_pickup: "#30CFF2",
  order_shipped: "#F2308D",
  order_delivered: "#30F238",
  order_pending: "#F29930",
  order_cancelled: "#F23030",
  order_returned: "#CC2929",

  // order status text background colors
  order_accepted_bg: "#F9F2FC",
  order_activated_bg: "#FCFBF2",
  order_processing_bg: "#F2F5FC",
  order_awaiting_pickup_bg: "#F2FBFC",
  order_shipped_bg: "#FCF2F7",
  order_delivered_bg: "#F2FCF3",
  order_pending_bg: "#FCF8F2",
  order_cancelled_bg: "#FCF2F2",
  order_returned_bg: "#FCF2F2",

  // item delivery status text color
  item_yet_to_be_dispatched: "#B230F2",
  item_activated: "#F2D330",
  item_yet_to_be_activated: "#F29930",
  item_processing: "#305BF2",
  item_ready_for_pickup: "#30CFF2",
  item_shipped: "#F2308D",
  item_delivered: "#30F238",
  item_cancelled: "#F23030",
  item_returned: "#CC2929",
  item_deactivated: "#991F1F",

  // item delivery status background color
  item_yet_to_be_dispatched_bg: "#F9F2FC",
  item_activated_bg: "#FCFBF2",
  item_yet_to_be_activated_bg: "#FCF8F2",
  item_processing_bg: "#F2F5FC",
  item_ready_for_pickup_bg: "#F2FBFC",
  item_shipped_bg: "#FCF2F7",
  item_delivered_bg: "#F2FCF3",
  item_cancelled_bg: "#FCF2F2",
  item_returned_bg: "#FCF2F2",
  item_deactivated_bg: "#FFEDEE",
};

export const getOrderStatusData = (orderStatus: String) => {
  let obj = {} as any;
  switch (orderStatus) {
    // order status
    case "ACCEPTED":
      obj = {
        status: "Accepted",
        color: colors.order_accepted,
        bg: colors.order_accepted_bg,
      };
      break;
    case "ACTIVATED":
      obj = {
        status: "Activated",
        color: colors.order_activated,
        bg: colors.order_activated_bg,
      };
      break;
    case "PROCESSING":
      obj = {
        status: "Processing",
        color: colors.order_processing,
        bg: colors.order_processing_bg,
      };
      break;
    case "AWAITING_PICKUP":
      obj = {
        status: "Awaiting Pickup",
        color: colors.order_awaiting_pickup,
        bg: colors.order_awaiting_pickup_bg,
      };
      break;
    case "SHIPPED":
      obj = {
        status: "Shipped",
        color: colors.order_shipped,
        bg: colors.order_shipped_bg,
      };
      break;
    case "DELIVERED":
      obj = {
        status: "Delivered",
        color: colors.order_delivered,
        bg: colors.order_delivered_bg,
      };
      break;
    case "PENDING":
      obj = {
        status: "Pending",
        color: colors.order_pending,
        bg: colors.order_pending_bg,
      };
      break;
    case "CANCELLED":
      obj = {
        status: "Cancelled",
        color: colors.order_cancelled,
        bg: colors.order_cancelled_bg,
      };
      break;
    case "RETURNED":
      obj = {
        status: "Returned",
        color: colors.order_returned,
        bg: colors.order_returned_bg,
      };
      break;

    // item status
    case "YET_TO_BE_DISP":
      obj = {
        status: "Yet to be Dispatched",
        color: colors.item_yet_to_be_dispatched,
        bg: colors.item_yet_to_be_dispatched_bg,
      };
      break;
    case "YET_TO_BE_DISPATCHED":
      obj = {
        status: "Yet to be Dispatched",
        color: colors.item_yet_to_be_dispatched,
        bg: colors.item_yet_to_be_dispatched_bg,
      };
      break;
    case "YET_TO_BE_ACTIVATED":
      obj = {
        status: "Yet to be Activated",
        color: colors.item_yet_to_be_activated,
        bg: colors.item_yet_to_be_activated_bg,
      };
      break;
    case "READY_FOR_PICKUP":
      obj = {
        status: "Ready for Pickup",
        color: colors.item_ready_for_pickup,
        bg: colors.item_ready_for_pickup_bg,
      };
      break;
    case "DEACTIVATED":
      obj = {
        status: "Deactivated",
        color: colors.item_deactivated,
        bg: colors.item_deactivated_bg,
      };
      break;
    default:
      break;
  }
  return obj;
};
export const currencyPicker: any = [
  { name: "Indian Rupee (₹) - INR", code: "INR" },
  { name: "US Dollar ($) - USD", code: "USD" },
  { name: "Euro (€) - EUR", code: "EUR" },
  { name: "British Pound (£) - GBP", code: "GBP" },
];

export const LearningSchemas: any = `{
"@context": "https://schema.org",
"@type": "FAQPage",
"mainEntity": [
  {
  "@type": "Question",
  "name": "What is Taxmann’s Learning?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Taxmann’s Learning is an endeavour to connect the experts with the learners seeking to upskill their knowledge in tax and corporate laws. This initiative uses three formats for knowledge-sharing: Webinars, Workshops & Masterclasses."
    }
  },
  {
  "@type": "Question",
  "name": "Whom will I learn from?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The experts from diversified fields share their knowledge and insights on complex & new concepts, new developments, amendments, case laws, etc. These experts have at least 10 years of core experience in the respective field relevant to the session."
    }
  },
  {
  "@type": "Question",
  "name": "What will I learn?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "A detailed agenda for an event is curated jointly by Taxmann’s Editorial team and the speaker. The team ensures that the session’s agenda should be such that it provides 360-degree coverage of the concept. In a workshop & masterclass, the experts share the background material, specimen, formats, excel templates, etc., to enable the user to implement the learning practically."
    }
  },
  {
  "@type": "Question",
  "name": "What topic is selected for the session?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "We do the sessions on the concepts of Income-tax, GST, FEMA, Accounting Standards, IBC, SEBI, and so on. Our editorial team finds new and complex topics based on three factors:\n\n• Ongoing Litigations\n• Upcoming Compliances\n• New Developments\n\nOur team discusses the suggestive topics with the experts to incubate the agendas and deliverables. Once we reach a consensus on a topic, it is selected for the session."
    }
  },
  {
  "@type": "Question",
  "name": "Can I suggest a topic for the session?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The users can also suggest a topic for the session. Furthermore, we can also conduct an exclusive private training session for your team members on the topic you choose."
    }
  },
  {
  "@type": "Question",
  "name": "How can I join the session?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "All our events are live, interactive online sessions. Non-subscribers can watch the sessions live on our platform, Zoom, or Taxmann's social media channels; however, recordings will not be available to them. Subscribers can join the sessions live and also access the recordings later. Workshops and masterclasses are exclusively hosted on Zoom."
    }
  },
  {
  "@type": "Question",
  "name": "What is the average duration of a session?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "• The average duration of a webinar is 45 minutes to 60 minutes.\n• The average duration of a workshop is 3 to 5 hours.\n• The average duration of a masterclass is 15 to 18 hours."
    }
  },
  {
  "@type": "Question",
  "name": "Do I get a certificate for joining the session?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, we provide a certificate to the users who join a workshop and masterclass session."
    }
  },
  {
  "@type": "Question",
  "name": "Why do you offer an introductory price, and how long does it last?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "We want to allow new subscribers to explore our platform at a lower cost. The introductory price applies to your first subscription term, valid until 31st May 2025. After this initial term, you’ll be charged the standard price upon renewal."
    }
  },
  {
  "@type": "Question",
  "name": "What happens after the introductory period ends?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Once your introductory term ends, you will need to renew your subscription at the standard rate to maintain access to the platform. We’ll notify you before your subscription expires so you can renew on time."
    }
  },
  {
  "@type": "Question",
  "name": "How do I know what workshops are included in my subscription?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Your subscription includes access to any 5 live or recorded events (within 3 months from the event date) at no additional cost. Once this limit is reached, you can purchase further live or recorded events at a 50% discount. Recorded events older than 3 months are available for unlimited access at no extra charge."
    }
  },
  {
  "@type": "Question",
  "name": "What access do I have to masterclasses in my subscription?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Masterclasses are not included in standard credits but can be purchased at a 50% discount."
    }
  },
  {
  "@type": "Question",
  "name": "Do I have free access to workshops and masterclasses in my free trial?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, the free trial includes access to up to 2 recorded sessions of workshops or masterclasses at no extra cost. Additional sessions can be purchased at full price."
    }
  },
  {
  "@type": "Question",
  "name": "I see a mention of a 3-month waiting period for recorded events. Does this
  apply to all events?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "No, this does not apply to all events. Webinar recordings are available immediately without any waiting period. For workshops, your subscription includes access to any 5 live or recorded events (within 3 months from the event date) at no extra cost. After this limit, additional events can be purchased at a 50% discount. For masterclasses, live or recorded events (within 3 months from the event date) are available at a 50% discount. All workshop and masterclass recordings older than 3 months are available for unlimited access at no extra cost. Any exceptions for premium events will be clearly mentioned on the event page."
    }
  },
  {
  "@type": "Question",
  "name": "Does “1 device at a time” mean I can only ever watch on one device?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Not exactly. You can log in on multiple devices (e.g., phone, tablet, laptop), but you can only use one device at a time to watch live or recorded content. If you switch devices, just make sure to log out on the previous device or end that stream. This policy prevents unauthorised sharing and helps us maintain fair access for all."
    }
  },
  {
  "@type": "Question",
  "name": "Do you offer discounts for multiple users in a single organisation?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, we offer discounts for multi-user access or enterprise-level subscriptions. For more details, please contact us."
    }
  },
  {
  "@type": "Question",
  "name": "Can I cancel my subscription, and will I get a refund?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes. You can request cancellation via your account settings. Refunds are at the company’s discretion and may be provided if the cancellation is requested within the first 7 days, depending on the content consumed after subscription activation. After 7 days, refunds are generally not provided, but you’ll retain access until the end of the current billing cycle."
    }
  }
]
}`;
